import React from 'react';
import { Separator as AriaSeparator } from 'react-aria-components';

import { tv } from '../../tv';

/**
 * A hairline between two regions, on the one divider step every slot edge
 * and menu separator use. It carries no spacing: the room around a rule is
 * the parent's gap. Vertical stretches to the row it stands in.
 */
export interface DividerProps {
  /** The axis the rule runs along. Vertical stands inside a row. */
  orientation?: 'horizontal' | 'vertical';
  id?: string;
}

const dividerStyles = tv({
  base: 'ck:m-0 ck:border-0 ck:border-border-divider',
  variants: {
    orientation: {
      horizontal: 'ck:w-full ck:border-t',
      vertical: 'ck:self-stretch ck:border-l',
    },
  },
  defaultVariants: { orientation: 'horizontal' },
});

export const Divider = React.forwardRef<HTMLElement, DividerProps>(function Divider(
  { orientation = 'horizontal', id },
  ref,
) {
  return (
    <AriaSeparator
      ref={ref}
      id={id}
      orientation={orientation}
      elementType={orientation === 'horizontal' ? 'hr' : 'div'}
      className={dividerStyles({ orientation })}
      data-component="divider"
    />
  );
});
